/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { Fieldobject } from './_mixin.mixin';

export default $ => css`
  ${new Fieldobject('flex-h').include(
    $,
    css`
      display: flex;
      flex-direction: row;
      > :not(:first-of-type) {
        margin-right: 12px;
      }
      > .f1 {
        flex: 1
      }
    `
  )}

  ${new Fieldobject('flex-v').include(
    $,
    css`
      display: flex;
      flex-direction: column;
      > :not(:first-of-type) {
        margin-bottom: 12px;
      }
    `
  )}
`;
